/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BillingFrequency } from './BillingFrequency';
import {
    BillingFrequencyFromJSON,
    BillingFrequencyFromJSONTyped,
    BillingFrequencyToJSON,
} from './BillingFrequency';
import type { WebApiModelsEnumerationTypesMembershipProductType } from './WebApiModelsEnumerationTypesMembershipProductType';
import {
    WebApiModelsEnumerationTypesMembershipProductTypeFromJSON,
    WebApiModelsEnumerationTypesMembershipProductTypeFromJSONTyped,
    WebApiModelsEnumerationTypesMembershipProductTypeToJSON,
} from './WebApiModelsEnumerationTypesMembershipProductType';

/**
 * Unified table for membership types and addons
 * @export
 * @interface WebApiModelsMembershipProduct
 */
export interface WebApiModelsMembershipProduct {
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsMembershipProduct
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsMembershipProduct
     */
    companyId?: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMembershipProductType}
     * @memberof WebApiModelsMembershipProduct
     */
    membershipProductType?: WebApiModelsEnumerationTypesMembershipProductType;
    /**
     * 
     * @type {string}
     * @memberof WebApiModelsMembershipProduct
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiModelsMembershipProduct
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsMembershipProduct
     */
    price?: number;
    /**
     * 
     * @type {BillingFrequency}
     * @memberof WebApiModelsMembershipProduct
     */
    billingFrequency?: BillingFrequency;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsMembershipProduct
     */
    sortOrder?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiModelsMembershipProduct
     */
    visiblePublic?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiModelsMembershipProduct
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WebApiModelsMembershipProduct
     */
    updatedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsMembershipProduct
     */
    createdBy?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiModelsMembershipProduct
     */
    updatedBy?: number | null;
}

/**
 * Check if a given object implements the WebApiModelsMembershipProduct interface.
 */
export function instanceOfWebApiModelsMembershipProduct(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiModelsMembershipProductFromJSON(json: any): WebApiModelsMembershipProduct {
    return WebApiModelsMembershipProductFromJSONTyped(json, false);
}

export function WebApiModelsMembershipProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsMembershipProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'membershipProductType': !exists(json, 'membershipProductType') ? undefined : WebApiModelsEnumerationTypesMembershipProductTypeFromJSON(json['membershipProductType']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'billingFrequency': !exists(json, 'billingFrequency') ? undefined : BillingFrequencyFromJSON(json['billingFrequency']),
        'sortOrder': !exists(json, 'sortOrder') ? undefined : json['sortOrder'],
        'visiblePublic': !exists(json, 'visiblePublic') ? undefined : json['visiblePublic'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (json['updatedAt'] === null ? null : new Date(json['updatedAt'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function WebApiModelsMembershipProductToJSON(value?: WebApiModelsMembershipProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'companyId': value.companyId,
        'membershipProductType': WebApiModelsEnumerationTypesMembershipProductTypeToJSON(value.membershipProductType),
        'name': value.name,
        'description': value.description,
        'price': value.price,
        'billingFrequency': BillingFrequencyToJSON(value.billingFrequency),
        'sortOrder': value.sortOrder,
        'visiblePublic': value.visiblePublic,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt === null ? null : value.updatedAt.toISOString()),
        'createdBy': value.createdBy,
        'updatedBy': value.updatedBy,
    };
}

